import { Dispatch } from 'redux';
import { RootState } from '../index';
import { getFilteredMenu } from '../../config/defaultMenu';

/**
 * Load the sidebar menu from the static default definition.
 *
 * Filtering is based on:
 *   1. Environment (eu.pons.io → restricted, dev → partial, localhost → full)
 *   2. Org type   (law_firm, solo_lawyer, business, individual_client, in_house_team)
 *
 * No API call is made - the menu ships with each frontend deploy.
 *
 * @param forceRefresh - Force a rebuild (e.g. after org type becomes available)
 */
export const fetchMenuStructure = (forceRefresh = false) => {
  return (dispatch: Dispatch<any>, getState: () => RootState) => {
    const state = getState();
    const cachedMenu = state.menu?.menuStructure;
    const orgType = state.user?.userInfo?.org_type ?? null;

    // Skip if already loaded and not forcing refresh
    if (!forceRefresh && cachedMenu && cachedMenu.length > 0) {
      return;
    }

    dispatch({ type: 'MENU_FETCH_START' });

    try {
      const filteredMenu = getFilteredMenu(orgType);

      dispatch({
        type: 'MENU_FETCH_SUCCESS',
        payload: filteredMenu,
      });
    } catch (error: any) {
      dispatch({
        type: 'MENU_FETCH_FAILURE',
        payload: error.message || 'Failed to build menu',
      });
    }
  };
};

/**
 * Clear the cached menu structure
 * Used on logout or when menu needs to be refreshed
 */
export const clearMenu = () => {
  return {
    type: 'MENU_CLEAR',
  };
};
